const currencies = [
    { value: 'usd', label: 'USD' },
    { value: 'eur', label: 'EUR' },
    { value: 'gbp', label: 'GBP' },
    { value: 'inr', label: 'INR' },
    { value: 'aud', label: 'AUD' },
    { value: 'cad', label: 'CAD' },
    { value: 'jpy', label: 'JPY' },
    { value: 'cny', label: 'CNY' },
    { value: 'chf', label: 'CHF' },
    { value: 'sek', label: 'SEK' },
    { value: 'nzd', label: 'NZD' },
    { value: 'mxn', label: 'MXN' },
    { value: 'sgd', label: 'SGD' },
    { value: 'hkd', label: 'HKD' },
    { value: 'krw', label: 'KRW' },
    { value: 'brl', label: 'BRL' },
    { value: 'zar', label: 'ZAR' },
    { value: 'try', label: 'TRY' },
    { value: 'rub', label: 'RUB' },
    { value: 'aed', label: 'AED' },
    { value: 'pkr', label: 'PKR' },
    { value: 'idr', label: 'IDR' },
    { value: 'dkk', label: 'DKK' },
    { value: 'nok', label: 'NOK' },
    { value: 'kwd', label: 'KWD' },
    { value: 'bdt', label: 'BDT' },
    { value: 'vnd', label: 'VND' },
    { value: 'myr', label: 'MYR' },
    { value: 'php', label: 'PHP' },
    { value: 'thb', label: 'THB' },
    { value: 'czk', label: 'CZK' },
    { value: 'pln', label: 'PLN' },
    { value: 'mad', label: 'MAD' },
    { value: 'ngn', label: 'NGN' },
    { value: 'kes', label: 'KES' },
];


export { currencies }
